import { Eye, EyeOff } from 'lucide-react';
import { useState, forwardRef } from 'react';
import { baseFontClass } from '@/components/base/Typography';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';
import { cn } from '@/utils';

export { Input } from '@/components/ui/input';
export { Textarea } from '@/components/ui/textarea';

export const PrimaryInput = forwardRef(({ className, type, inputRef, ...props }, ref) => {
  return (
    <input
      ref={inputRef || ref}
      className={cn(
        'border-input bg-background ring-offset-background placeholder:text-muted-foreground focus-visible:ring-ring flex h-10 w-full rounded-md border px-3 py-2 text-sm file:border-0 file:bg-transparent file:text-sm file:font-medium focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50',
        baseFontClass,
        className,
      )}
      type={type}
      {...props}
    />
  );
});

PrimaryInput.displayName = 'PrimaryInput';

export const AuthInput = ({ className, ...rest }) => {
  return (
    <Input
      className={cn(
        'md:text-md h-12 px-2 py-1 text-sm sm:px-3 sm:py-1.5 sm:text-base md:px-4 md:py-2',
        className,
      )}
      {...rest}
    />
  );
};

export const PasswordInput = ({ className, ...rest }) => {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <div className="relative">
      <Input
        className={cn(
          'md:text-md h-12 px-2 py-1 text-sm sm:px-3 sm:py-1.5 sm:text-base md:px-4 md:py-2',
          className,
        )}
        type={showPassword ? 'text' : 'password'}
        {...rest}
      />
      <button
        className="absolute inset-y-0 right-0 flex items-center justify-center p-2 sm:p-3 md:p-4"
        type="button"
        onClick={() => setShowPassword(!showPassword)}
      >
        {showPassword ? (
          <EyeOff className="text-muted-foreground h-4 w-4 sm:h-4.5 sm:w-4.5 md:h-5 md:w-5" />
        ) : (
          <Eye className="text-muted-foreground h-4 w-4 sm:h-4.5 sm:w-4.5 md:h-5 md:w-5" />
        )}
      </button>
    </div>
  );
};

export const PrimaryTextarea = ({ className, ...rest }) => {
  return (
    <Textarea
      className={cn(
        'md:text-md px-2 py-1 text-sm sm:px-3 sm:py-1.5 sm:text-base md:px-4 md:py-2',
        className,
      )}
      {...rest}
    />
  );
};
